/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics$1 = function(d, b) {
    extendStatics$1 = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics$1(d, b);
};

function __extends$1(d, b) {
    extendStatics$1(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign$1 = function() {
    __assign$1 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var StarlingError = /** @class */ (function (_super) {
    __extends(StarlingError, _super);
    function StarlingError(code, message, originError) {
        var _this = _super.call(this, message) || this;
        _this.code = code;
        _this.message = message;
        _this.originError = originError;
        _this.name = 'StarlingError';
        _this.code = code;
        _this.message = message;
        _this.originError = originError;
        if (Error.captureStackTrace)
            Error.captureStackTrace(_this, _this.constructor);
        return _this;
    }
    return StarlingError;
}(Error));
var MAP_ERROR = {
    CHECK_VERSION_ERROR: {
        ERROR_CODE: 100,
        ERROR_MESSAGE: 'Request for checkVersion failed!'
    },
    LOAD_TEXT_ERROR: {
        ERROR_CODE: 101,
        ERROR_MESSAGE: 'Request for loadText failed!'
    },
    TEST_ERROR: {
        ERROR_CODE: 102,
        ERROR_MESSAGE: 'Request for loadTestText failed!'
    },
    API_PARAMS_ERROR: {
        ERROR_CODE: 103,
        ERROR_MESSAGE: 'Request failed, confirm your apiKey and namespace is correct'
    },
    PARAMS_ERROR: {
        ERROR_CODE: 110,
        ERROR_MESSAGE: 'Check your params, parameter apiKey, namespace and zoneHost is required!'
    },
    PARAMS_ERROR_2: {
        ERROR_CODE: 111,
        ERROR_MESSAGE: 'Check your params, parameter request and store is required!'
    },
    CACHE_ERROR: {
        ERROR_CODE: 112,
        ERROR_MESSAGE: 'Cache error!'
    },
    VERSION_NOT_FOUND: {
        ERROR_CODE: 120,
        ERROR_MESSAGE: 'Version is not found, please check your param [version]!'
    },
    OTHER_ERROR: {
        ERROR_CODE: 200,
        ERROR_MESSAGE: 'Something Wrong!'
    }
};

var defaultOptions = {
    zone: 'CN',
    locale: 'zh',
    timeout: 5000,
    test: false,
    mode: 'normal',
    format: 'merged',
    lazyUpdate: false,
    fallbackLang: ['zh'],
    tracker: function () { }
};
function createOptions(options) {
    options = Object.assign({}, defaultOptions, options);
    var namespace = options.namespace, apiKey = options.apiKey;
    var request = options.request, store = options.store, zoneHost = options.zoneHost, test = options.test;
    if (test)
        options.mode = 'test';
    options.namespace = namespace = namespace
        ? Array.isArray(namespace)
            ? namespace
            : [namespace]
        : [];
    options.apiKey = apiKey = apiKey || options.api_key;
    if (!request || !store) {
        var _a = MAP_ERROR.PARAMS_ERROR_2, ERROR_CODE = _a.ERROR_CODE, ERROR_MESSAGE = _a.ERROR_MESSAGE;
        throw new StarlingError(ERROR_CODE, ERROR_MESSAGE, null);
    }
    if (!apiKey || !namespace.length || !zoneHost) {
        var _b = MAP_ERROR.PARAMS_ERROR, ERROR_CODE = _b.ERROR_CODE, ERROR_MESSAGE = _b.ERROR_MESSAGE;
        throw new StarlingError(ERROR_CODE, ERROR_MESSAGE, null);
    }
    return options;
}

var Request = /** @class */ (function () {
    function Request(options) {
        this.options = options;
        this.options = options;
    }
    Request.prototype.getText = function (namespace, localVersion) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._request(namespace, localVersion)];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res];
                }
            });
        });
    };
    Request.prototype.getTexts = function (namespaces) {
        var _this = this;
        return Promise.all(namespaces.map(function (_a) {
            var ns = _a[0], version = _a[1];
            return _this.getText(ns, version);
        }));
    };
    Request.prototype._request = function (namespace, localVersion) {
        return __awaiter(this, void 0, void 0, function () {
            var getReleaseVersion, releaseVersion, url, _a, request, timeout, res, _b, status, message, _c, ERROR_CODE_1, ERROR_MESSAGE_1, _d, ERROR_CODE, ERROR_MESSAGE;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        getReleaseVersion = this.options.getReleaseVersion;
                        releaseVersion = getReleaseVersion(namespace);
                        if (namespace && releaseVersion && localVersion) {
                            return [2 /*return*/, {}];
                        }
                        url = this.getUrl(namespace, localVersion);
                        _a = this.options, request = _a.request, timeout = _a.timeout;
                        return [4 /*yield*/, request(url, { timeout: timeout })];
                    case 1:
                        res = _e.sent();
                        _b = res.data, status = _b.status, message = _b.message;
                        // 200 表示成功，1000 表示参数异常
                        if (+status === 200)
                            return [2 /*return*/, this._mapResponse(message)
                                // 1001 releaseVersion 不存在
                            ];
                        // 1001 releaseVersion 不存在
                        if (+status === 1001) {
                            _c = MAP_ERROR.VERSION_NOT_FOUND, ERROR_CODE_1 = _c.ERROR_CODE, ERROR_MESSAGE_1 = _c.ERROR_MESSAGE;
                            throw new StarlingError(ERROR_CODE_1, ERROR_MESSAGE_1);
                        }
                        _d = MAP_ERROR.API_PARAMS_ERROR, ERROR_CODE = _d.ERROR_CODE, ERROR_MESSAGE = _d.ERROR_MESSAGE;
                        throw new StarlingError(ERROR_CODE, ERROR_MESSAGE);
                }
            });
        });
    };
    Request.prototype.getUrl = function (namespace, localVersion) {
        var _a = this.options, apiKey = _a.apiKey, locale = _a.locale, fallbackLang = _a.fallbackLang, zoneHost = _a.zoneHost, mode = _a.mode, getReleaseVersion = _a.getReleaseVersion;
        var langs = [locale].concat(fallbackLang);
        var url = zoneHost + "/check_and_get_text/" + apiKey + "/" + mode + "/" + namespace + "?lang=" + langs;
        var releaseVersion = getReleaseVersion(namespace);
        if (releaseVersion) {
            url = zoneHost + "/text_by_release_version/" + apiKey + "/" + mode + "/" + namespace + "/" + releaseVersion + "?lang=" + langs;
        }
        if (typeof localVersion === 'string')
            url += "&version=" + localVersion;
        return url;
    };
    Request.prototype._mapResponse = function (res) {
        if (!res)
            return {};
        return Object.keys(res).reduce(function (acc, key) {
            var newKey = key.toLowerCase();
            acc[newKey] = res[key];
            return acc;
        }, {});
    };
    return Request;
}());

var LocalCache = /** @class */ (function () {
    function LocalCache(options) {
        this.options = options;
        this.options = options;
    }
    LocalCache.prototype._setCache = function (key, val) {
        try {
            return this.options.store.set(key, val);
        }
        catch (err) {
            var ERROR_CODE = MAP_ERROR.CACHE_ERROR.ERROR_CODE;
            this.options.tracker('cache_error', {
                code: ERROR_CODE,
                message: err.message,
                stack: err.stack
            });
            return;
        }
    };
    LocalCache.prototype._getCache = function (key) {
        try {
            return this.options.store.get(key);
        }
        catch (err) {
            var ERROR_CODE = MAP_ERROR.CACHE_ERROR.ERROR_CODE;
            this.options.tracker('cache_error', {
                code: ERROR_CODE,
                message: err.message,
                stack: err.stack
            });
            return;
        }
    };
    LocalCache.prototype.getVersion = function (namespace) {
        var _a = this.options, apiKey = _a.apiKey, locale = _a.locale, getReleaseVersion = _a.getReleaseVersion;
        var key = "version." + apiKey + "." + namespace + "." + locale;
        var releaseVersion = getReleaseVersion(namespace);
        if (releaseVersion) {
            key += "." + releaseVersion;
        }
        // 如果本地缓存被不小心清掉了，版本也不单独返回
        if (!this.getText(namespace)) {
            return null;
        }
        return this._getCache(key);
    };
    LocalCache.prototype.getVersions = function (namespaces) {
        var _this = this;
        return Promise.all(namespaces.map(function (ns) { return _this.getVersion(ns); }));
    };
    LocalCache.prototype.getText = function (namespace) {
        var _a = this.options, apiKey = _a.apiKey, locale = _a.locale, getReleaseVersion = _a.getReleaseVersion;
        var key = "text." + apiKey + "." + namespace + "." + locale;
        var releaseVersion = getReleaseVersion(namespace);
        if (releaseVersion) {
            key += "." + releaseVersion;
        }
        return this._getCache(key);
    };
    // 允许 store 返回值为 promise，支持异步与缓存的交互
    LocalCache.prototype.getTexts = function (namespaces) {
        var _this = this;
        return Promise.all(namespaces.map(function (ns) { return _this.getText(ns); }));
    };
    // 更新指定的空间缓存
    LocalCache.prototype.refresh = function (namespaces, textRes, newVers, langArr) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, apiKey, getReleaseVersion, promises, text;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.options, apiKey = _a.apiKey, getReleaseVersion = _a.getReleaseVersion;
                        promises = [];
                        textRes.forEach(function (text, i) {
                            var textKey = "text." + apiKey + "." + namespaces[i] + "." + langArr[i];
                            var versionKey = "version." + apiKey + "." + namespaces[i] + "." + langArr[i];
                            var releaseVersion = getReleaseVersion(namespaces[i]);
                            if (releaseVersion) {
                                textKey += "." + releaseVersion;
                                versionKey += "." + releaseVersion;
                            }
                            promises.push(_this._setCache(textKey, textRes[i]));
                            promises.push(_this._setCache(versionKey, newVers[i]));
                        });
                        // 等待缓存更新完成
                        return [4 /*yield*/, Promise.all(promises)];
                    case 1:
                        // 等待缓存更新完成
                        _b.sent();
                        text = textRes.reduce(function (acc, cur) {
                            return Object.assign(acc, cur);
                        }, {});
                        return [2 /*return*/, text];
                }
            });
        });
    };
    return LocalCache;
}());

function mergeTexts(arr1, arr2) {
    var arr = arr2 ? arr1.concat(arr2) : arr1;
    return arr.reduce(function (acc, cur) {
        return Object.assign(acc, cur);
    }, {});
}
var NamespaceGroup = /** @class */ (function () {
    function NamespaceGroup(list) {
        if (list === void 0) { list = []; }
        this._list = [];
        this._list = list;
    }
    Object.defineProperty(NamespaceGroup.prototype, "length", {
        get: function () {
            return this._list.length;
        },
        enumerable: false,
        configurable: true
    });
    NamespaceGroup.prototype.getList = function () {
        return this._list;
    };
    NamespaceGroup.prototype.getNamespaces = function () {
        return this._list.map(function (item) { return item.namespace; });
    };
    NamespaceGroup.prototype.addNamespace = function (ns) {
        this._list.push(ns);
    };
    NamespaceGroup.prototype.insertTexts = function (textsArr) {
        this._list.forEach(function (ns, i) {
            ns.texts = textsArr[i];
        });
    };
    NamespaceGroup.prototype.sortByPrior = function () {
        this._list.sort(function (a, b) { return a.prior - b.prior; });
        return this._list;
    };
    NamespaceGroup.prototype.concat = function (nsg) {
        return new NamespaceGroup(this._list.concat(nsg.getList()));
    };
    return NamespaceGroup;
}());
var TextManager = /** @class */ (function () {
    function TextManager(request, localCache, options) {
        this._promiseRefresh = Promise.resolve(null);
        this.remote = request;
        this.local = localCache;
        this.options = options;
    }
    TextManager.prototype._checkVersions = function (namespaces) {
        return __awaiter(this, void 0, void 0, function () {
            var locale, localVersions, namespaceWithVersion, resArr, equalNs, diffNs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        locale = this.options.locale;
                        return [4 /*yield*/, this.local.getVersions(namespaces)];
                    case 1:
                        localVersions = _a.sent();
                        namespaceWithVersion = namespaces.map(function (ns, i) { return [ns, localVersions[i]]; });
                        return [4 /*yield*/, this.remote.getTexts(namespaceWithVersion)];
                    case 2:
                        resArr = _a.sent();
                        equalNs = new NamespaceGroup();
                        diffNs = new NamespaceGroup();
                        namespaces.forEach(function (ns, i) {
                            var _a = resArr[i], updated = _a.updated, version = _a.version, data = _a.data, lang = _a.lang;
                            if (!updated) {
                                equalNs.addNamespace({ namespace: ns, prior: i, version: localVersions[i], lang: locale });
                            }
                            else {
                                diffNs.addNamespace({ namespace: ns, prior: i, version: version, texts: data, lang: lang });
                            }
                        });
                        return [2 /*return*/, { equalNs: equalNs, diffNs: diffNs }];
                }
            });
        });
    };
    TextManager.prototype.waitForRefresh = function () {
        return this._promiseRefresh;
    };
    TextManager.prototype._refresh = function (diffNs) {
        var diffList = diffNs.getList();
        var nsArr = [];
        var versionArr = [];
        var txtArr = [];
        var langArr = [];
        diffList.forEach(function (i) {
            nsArr.push(i.namespace);
            versionArr.push(i.version);
            txtArr.push(i.texts);
            langArr.push(i.lang);
        });
        return this.local.refresh(nsArr, txtArr, versionArr, langArr);
    };
    TextManager.prototype._getLocalTexts = function (nsg) {
        return __awaiter(this, void 0, void 0, function () {
            var texts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.local.getTexts(nsg.getNamespaces())];
                    case 1:
                        texts = _a.sent();
                        nsg.insertTexts(texts);
                        return [2 /*return*/, texts];
                }
            });
        });
    };
    TextManager.prototype.load = function (namespaces) {
        return __awaiter(this, void 0, void 0, function () {
            var format, _a, equalNs, diffNs, texts, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        format = this.options.format;
                        return [4 /*yield*/, this._checkVersions(namespaces)];
                    case 1:
                        _a = _d.sent(), equalNs = _a.equalNs, diffNs = _a.diffNs;
                        if (!equalNs.length) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._getLocalTexts(equalNs)];
                    case 2:
                        _d.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _d.label = 4;
                    case 4:
                        texts = this._formatTexts(format, diffNs.concat(equalNs));
                        _c = diffNs.length;
                        if (!_c) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._refresh(diffNs)];
                    case 5:
                        _c = (_d.sent());
                        _d.label = 6;
                    case 6:
                        return [2 /*return*/, {
                                texts: texts,
                                diffNs: diffNs.getNamespaces(),
                                equalNs: equalNs.getNamespaces()
                            }];
                }
            });
        });
    };
    /**
     * 获取本地缓存文案
     * @param namespaces 空间列表
     */
    TextManager.prototype._getCacheText = function (namespaces) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, locale, format, txtArr, versionArr, nsgList, nsg;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.options, locale = _a.locale, format = _a.format;
                        return [4 /*yield*/, this.local.getTexts(namespaces)];
                    case 1:
                        txtArr = _b.sent();
                        return [4 /*yield*/, this.local.getVersions(namespaces)];
                    case 2:
                        versionArr = _b.sent();
                        nsgList = txtArr
                            .map(function (txt, i) {
                            if (!txt)
                                return;
                            return {
                                namespace: namespaces[i],
                                version: versionArr[i],
                                lang: locale,
                                texts: txt
                            };
                        })
                            .filter(function (i) { return !!i; });
                        nsg = new NamespaceGroup(nsgList);
                        return [2 /*return*/, this._formatTexts(format, nsg)];
                }
            });
        });
    };
    TextManager.prototype.lazyLoad = function (namespaces) {
        return __awaiter(this, void 0, void 0, function () {
            var texts, isLocalEmpty, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._getCacheText(namespaces)];
                    case 1:
                        texts = _a.sent();
                        isLocalEmpty = Object.keys(texts).length === 0;
                        this._promiseRefresh = this.load(namespaces);
                        if (!isLocalEmpty) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._promiseRefresh];
                    case 2:
                        // 等待获取远程文案
                        res = _a.sent();
                        texts = res.texts;
                        _a.label = 3;
                    case 3: return [2 /*return*/, {
                            texts: texts,
                            diffNs: isLocalEmpty ? res && res.diffNs : [],
                            equalNs: isLocalEmpty ? res && res.equalNs : namespaces
                        }];
                }
            });
        });
    };
    TextManager.prototype._formatTexts = function (type, nsg) {
        if (type === 'splitted') {
            var list = nsg.getList();
            return list.reduce(function (acc, cur) {
                var namespace = cur.namespace, lang = cur.lang, texts = cur.texts, version = cur.version;
                acc[namespace] = { lang: lang, texts: texts, version: version };
                return acc;
            }, {});
        }
        else {
            // 保证文案合并的顺序，后面的空间会覆盖前面空间的文案。
            var textsArr = nsg.sortByPrior().map(function (i) { return i.texts; });
            return mergeTexts(textsArr);
        }
    };
    return TextManager;
}());

if (typeof Object.assign !== 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, 'assign', {
        value: function assign(target) {
            if (target === null || target === undefined) {
                throw new TypeError('Cannot convert undefined or null to object');
            }
            var to = Object(target);
            for (var index = 1; index < arguments.length; index++) {
                // eslint-disable-next-line prefer-rest-params
                var nextSource = arguments[index];
                if (nextSource !== null && nextSource !== undefined) {
                    for (var nextKey in nextSource) {
                        // Avoid bugs when hasOwnProperty is shadowed
                        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                }
            }
            return to;
        },
        writable: true,
        configurable: true
    });
}

var MAP_EVENT_NAME = {
    EVENT_EXCEPTION: 'client_exception',
    EVENT_LOAD: 'client_load',
    EVENT_CACHE: 'client_cache',
    EVENT_LOAD_TIME: 'client_load_time' // 文案获取时间
};
var Starling = /** @class */ (function () {
    function Starling(options) {
        this.setConfig(options);
    }
    Starling.prototype._init = function (options) {
        var _this = this;
        this.options = createOptions(options);
        var _a = this.options, apiKey = _a.apiKey, locale = _a.locale, zoneHost = _a.zoneHost, request = _a.request, timeout = _a.timeout, fallbackLang = _a.fallbackLang, store = _a.store, lazyUpdate = _a.lazyUpdate, test = _a.test, mode = _a.mode, format = _a.format;
        // 需要上报的公共参数- mode zone locale apiKey
        var commonParams = {
            mode: lazyUpdate ? 'lazy' : test ? 'test' : 'prod',
            zone: zoneHost,
            locale: locale,
            apiKey: apiKey
        };
        this._tracker = function (name, attrs) {
            try {
                // 打点失败了不应该影响正常业务
                _this.options.tracker(name, __assign$1(__assign$1({}, commonParams), attrs));
            }
            catch (error) {
                console.log(error);
            }
        };
        var getReleaseVersion = this._getReleaseVersionByNamespace.bind(this);
        var requester = new Request({
            request: request,
            timeout: timeout,
            apiKey: apiKey,
            locale: locale,
            zoneHost: zoneHost,
            fallbackLang: fallbackLang,
            mode: mode,
            getReleaseVersion: getReleaseVersion
        });
        var localCache = new LocalCache({
            apiKey: apiKey,
            locale: locale,
            store: store,
            tracker: this._tracker,
            getReleaseVersion: getReleaseVersion
        });
        this._textManager = new TextManager(requester, localCache, { locale: locale, format: format });
    };
    Starling.prototype._getReleaseVersionByNamespace = function (ns) {
        var namespaces = this.options.namespace;
        var releaseVersion = this.options.version;
        var version = null;
        if (Array.isArray(releaseVersion)) {
            var index = namespaces.findIndex(function (v) { return v === ns; });
            version = releaseVersion[index];
        }
        else if (releaseVersion && typeof releaseVersion === 'object') {
            version = releaseVersion[ns];
        }
        else if (typeof releaseVersion === 'string') {
            version = releaseVersion;
        }
        return version;
    };
    /**
     * 用于修改 starling 配置项
     * @param config
     */
    Starling.prototype.setConfig = function (config) {
        var options = Object.assign({}, this.options, config);
        this._init(options);
    };
    /**
     * 用于 lazy 模式下判断本地文案更新是否完成。
     *
     * @return {Promise<texts>} 返回本地更新的文案
     */
    Starling.prototype.waitForRefresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._textManager.waitForRefresh()];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res ? res.texts : null];
                }
            });
        });
    };
    Starling.prototype._load = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, namespace, lazyUpdate, namespaces, result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.options, namespace = _a.namespace, lazyUpdate = _a.lazyUpdate;
                        namespaces = namespace;
                        if (!lazyUpdate) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._textManager.lazyLoad(namespaces)];
                    case 1:
                        result = _b.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this._textManager.load(namespaces)];
                    case 3:
                        result = _b.sent();
                        _b.label = 4;
                    case 4: return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     * 从远端按需拉取需要更新的文案，并返回文案。
     *
     * @param {(param: texts) => void} onSuccess 调用成功的回调函数
     * @param {(error: StarlingError)} onError 调用失败的回调函数
     * @return {Promise<texts>} 远端拉取的文案
     */
    Starling.prototype.load = function (onSuccess, onError) {
        return __awaiter(this, void 0, void 0, function () {
            var start, namespaces, result, texts, diffNs, equalNs, diffLen, equalLen, namespacesLen, ratio, err_1, cacheText;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        start = Date.now();
                        namespaces = this.options.namespace;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 8]);
                        this._tracker(MAP_EVENT_NAME.EVENT_LOAD, { state: 'start', version: '0.5.2' });
                        return [4 /*yield*/, this._load()];
                    case 2:
                        result = _a.sent();
                        texts = result.texts, diffNs = result.diffNs, equalNs = result.equalNs;
                        onSuccess && onSuccess(texts);
                        this._tracker(MAP_EVENT_NAME.EVENT_LOAD_TIME, { time: Date.now() - start });
                        this._tracker(MAP_EVENT_NAME.EVENT_LOAD, { state: 'success', version: '0.5.2' });
                        diffLen = diffNs.length;
                        equalLen = equalNs.length;
                        namespacesLen = namespaces.length;
                        ratio = (equalLen / namespacesLen).toFixed(2);
                        this._tracker(MAP_EVENT_NAME.EVENT_CACHE, {
                            diffLen: diffLen,
                            diff: diffNs.join(','),
                            equalLen: equalLen,
                            equal: equalNs.join(','),
                            namespaces: equalNs.join(','),
                            namespacesLen: namespacesLen,
                            ratio: ratio
                        });
                        return [2 /*return*/, texts];
                    case 3:
                        err_1 = _a.sent();
                        this._tracker(MAP_EVENT_NAME.EVENT_LOAD, { state: 'fail' });
                        this._tracker(MAP_EVENT_NAME.EVENT_EXCEPTION, {
                            code: err_1.code,
                            message: err_1.message,
                            stack: err_1.stack
                        });
                        if (!(err_1 || {}).useWebCache) return [3 /*break*/, 7];
                        _a.label = 4;
                    case 4:
                        _a.trys.push([4, 6, , 7]);
                        return [4 /*yield*/, this._textManager._getCacheText(namespaces)];
                    case 5:
                        cacheText = _a.sent();
                        if (cacheText && typeof cacheText === 'object') {
                            err_1.response.data = cacheText;
                        }
                        else {
                            err_1.response.data = {};
                        }
                        return [3 /*break*/, 7];
                    case 6:
                        _a.sent();
                        return [3 /*break*/, 7];
                    case 7:
                        // 如果用户传入了 onError，不应该再抛出一个异常
                        // 那样用户还需要再处理失败的 Promise，duck 不必
                        if (onError) {
                            onError(err_1);
                        }
                        else {
                            return [2 /*return*/, Promise.reject(err_1)];
                        }
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    return Starling;
}());

function _defineProperty(e,t,i){return t in e?Object.defineProperty(e,t,{value:i,enumerable:!0,configurable:!0,writable:!0}):e[t]=i,e}var __assign=function(){return (__assign=Object.assign||function(e){for(var t,i=1,n=arguments.length;i<n;i++)for(var o in t=arguments[i])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e}).apply(this,arguments)};function __read(e,t){var i="function"==typeof Symbol&&e[Symbol.iterator];if(!i)return e;var n,o,r=i.call(e),s=[];try{for(;(void 0===t||t-- >0)&&!(n=r.next()).done;)s.push(n.value);}catch(e){o={error:e};}finally{try{n&&!n.done&&(i=r.return)&&i.call(r);}finally{if(o)throw o.error}}return s}function __spread(){for(var e=[],t=0;t<arguments.length;t++)e=e.concat(__read(arguments[t]));return e}function createCommonjsModule(e,t){return e(t={exports:{}},t.exports),t.exports}var js_cookie=createCommonjsModule(function(e,t){var i;i=function(){function e(){for(var e=0,t={};e<arguments.length;e++){var i=arguments[e];for(var n in i)t[n]=i[n];}return t}function t(e){return e.replace(/(%[0-9A-Z]{2})+/g,decodeURIComponent)}return function i(n){function o(){}function r(t,i,r){if("undefined"!=typeof document){"number"==typeof(r=e({path:"/"},o.defaults,r)).expires&&(r.expires=new Date(1*new Date+864e5*r.expires)),r.expires=r.expires?r.expires.toUTCString():"";try{var s=JSON.stringify(i);/^[\{\[]/.test(s)&&(i=s);}catch(e){}i=n.write?n.write(i,t):encodeURIComponent(String(i)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),t=encodeURIComponent(String(t)).replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent).replace(/[\(\)]/g,escape);var a="";for(var c in r)r[c]&&(a+="; "+c,!0!==r[c]&&(a+="="+r[c].split(";")[0]));return document.cookie=t+"="+i+a}}function s(e,i){if("undefined"!=typeof document){for(var o={},r=document.cookie?document.cookie.split("; "):[],s=0;s<r.length;s++){var a=r[s].split("="),c=a.slice(1).join("=");i||'"'!==c.charAt(0)||(c=c.slice(1,-1));try{var u=t(a[0]);if(c=(n.read||n)(c,u)||t(c),i)try{c=JSON.parse(c);}catch(e){}if(o[u]=c,e===u)break}catch(e){}}return e?o[e]:o}}return o.set=r,o.get=function(e){return s(e,!1)},o.getJSON=function(e){return s(e,!0)},o.remove=function(t,i){r(t,"",e(i,{expires:-1}));},o.defaults={},o.withConverter=i,o}(function(){})},e.exports=i();}),Memory=function(){function e(){this.cache={};}return e.prototype.setItem=function(e,t){this.cache[e]=t;},e.prototype.getItem=function(e){return this.cache[e]},e.prototype.removeItem=function(e){this.cache[e]=void 0;},e}();function isSupportLS(){try{return localStorage.setItem("_ranger-test-key","hi"),localStorage.getItem("_ranger-test-key"),localStorage.removeItem("_ranger-test-key"),!0}catch(e){return !1}}function isSupportSession(){try{return sessionStorage.setItem("_ranger-test-key","hi"),sessionStorage.getItem("_ranger-test-key"),sessionStorage.removeItem("_ranger-test-key"),!0}catch(e){return !1}}var local={getItem:function(e){try{var t=localStorage.getItem(e),i=t;try{t&&"string"==typeof t&&(i=JSON.parse(t));}catch(e){}return i||void 0}catch(e){}},setItem:function(e,t){try{var i="string"==typeof t?t:JSON.stringify(t);localStorage.setItem(e,i);}catch(e){}},removeItem:function(e){try{localStorage.removeItem(e);}catch(e){}},getCookie:function(e,t){try{return js_cookie.get(e,{domain:t||document.domain})}catch(e){return ""}},setCookie:function(e,t,i,n){try{var o=n||document.domain,r=+new Date+i;js_cookie.set(e,t,{expires:new Date(r),path:"/",domain:o});}catch(e){}},isSupportLS:isSupportLS()},session={getItem:function(e){try{var t=sessionStorage.getItem(e),i=t;try{t&&"string"==typeof t&&(i=JSON.parse(t));}catch(e){}return i||void 0}catch(e){}},setItem:function(e,t){try{var i="string"==typeof t?t:JSON.stringify(t);sessionStorage.setItem(e,i);}catch(e){}},removeItem:function(e){try{sessionStorage.removeItem(e);}catch(e){}},isSupportSession:isSupportSession()},Storage=function(){function e(e,t){this._storage=t&&"session"===t?session:!e&&local.isSupportLS?local:new Memory;}return e.prototype.getItem=function(e){return this._storage.getItem(e)},e.prototype.setItem=function(e,t){this._storage.setItem(e,t);},e.prototype.getCookie=function(e,t){return this._storage.getCookie(e,t)},e.prototype.setCookie=function(e,t,i,n){this._storage.setCookie(e,t,i,n);},e.prototype.removeItem=function(e){this._storage.removeItem(e);},e}(),LOG_URL={sg:"1fz22z22z1nz21z4mz4bz4bz1kz1az21z49z21z1ez4az22z1gz1iz22z1mz1iz24z4az1az1mz1k",va:"1fz22z22z1nz21z4mz4bz4bz1kz1az21z49z24z18z4az22z1gz1iz22z1mz1iz24z4az1az1mz1k",in:"1fz22z22z1nz21z4mz4bz4bz1kz1az21z49z24z18z49z23z21z1cz18z21z22z4ez18z4az22z1gz1iz22z1mz1iz24z4az1az1mz1k"},WEBID_URL="/v1/user/webid",TOB_URL="/tobid",REPORT_URL="/v1/list",GIF_URL="/v1/gif",SDK_VERSION="4.1.38_tcpy",ERROR={NO_URL:4001,IMG_ON:4e3,IMG_CATCH:4002,BEACON_FALSE:4003,XHR_ON:500,RESPONSE:5001,TIMEOUT:5005},CACHEKEY=function(e,t){return t?"__tea_cache_tokens_"+e:"__tea_cache_events_"+e},COOKIEKEY=function(e){return "__tea_cookie_tokens_"+e},SESSIONKEY=function(e){return "__tea_session_id_"+e},CONFIGKEY=function(e){return "__tea_cache_config_"+e};function xhr(e,t,i,n,o,r,s,a){try{var c=new XMLHttpRequest,u=a||"POST";c.open(u,""+e,!0),c.setRequestHeader("Content-Type","application/json; charset=utf-8"),o&&c.setRequestHeader("X-MCS-AppKey",""+o),s&&(c.withCredentials=!0),c.onload=function(){if(i){var e=null;if(c.responseText){try{e=JSON.parse(c.responseText);}catch(t){e={};}i(e);}}},r&&(c.timeout=r),r&&(c.ontimeout=function(){n&&n(t,ERROR.TIMEOUT);}),c.onerror=function(){c.abort(),n&&n(t,ERROR.XHR_ON);},c.send(JSON.stringify(t));}catch(e){}}var isSupportBeacon=function(){return !(!window.navigator||!window.navigator.sendBeacon)},NOOP=function(){},encodePayload=function(e){var t="";for(var i in e)e.hasOwnProperty(i)&&void 0!==e[i]&&(t+="&"+i+"="+encodeURIComponent(JSON.stringify(e[i])));return t="&"===t[0]?t.slice(1):t},sendByImg=function(e,t,i,n){try{var o=e.match(/\/v\d\//),r="";r=o?o[0]:-1!==e.indexOf("/v1/")?"/v1/":"/v2/";var s=e.split(r)[0];if(!s)return void n(e,t,ERROR.NO_URL);t.forEach(function(o){var r=encodePayload(o),a=new Image(1,1);a.onload=function(){a=null,i&&i();},a.onerror=function(){a=null,n&&n(e,t,ERROR.IMG_ON);},a.src=""+s+GIF_URL+"?"+r;});}catch(i){n&&n(e,t,ERROR.IMG_CATCH,i.message);}},request$1=function(e,t,i,n,o,r,s,a,c,u){var h=window.navigator.userAgent,d=-1!==window.navigator.appName.indexOf("Microsoft Internet Explorer")&&(-1!==h.indexOf("MSIE 8.0")||-1!==h.indexOf("MSIE 9.0")),f=!!n;if(!f&&d)sendByImg(e,i,o,r);else if(!f&&a)return isSupportBeacon()?(u?u():NOOP(),void(window.navigator.sendBeacon(e,JSON.stringify(i))?o():r(e,i,ERROR.BEACON_FALSE))):void sendByImg(e,i,o,r);s&&delete i.app_key,xhr(e,i,o,r,n,t,c);};function b(e){return e?(e^16*Math.random()>>e/4).toString(10):([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g,b)}var webid=function(){return b().replace(/-/g,"").slice(0,19)};function decrypto(e,t,i){if("string"==typeof e&&"number"==typeof t&&"number"==typeof i){var n,o=[];i=i<=25?i:i%25;var r=String.fromCharCode(i+97);n=e.split(r);for(var s=0;s<n.length;s++){var a=parseInt(n[s],i);a=1*a^t;var c=String.fromCharCode(a);o.push(c);}return o.join("")}}var decodeUrl=function(e){return decrypto(e,64,25)},Token=function(){function e(e,t,i,n){this.config=e,this.cfg=t,this.storage=new Storage(!1),this.appInfo=e.app_key||e.app_id,this.isNoWebid=e.disable_webid,this.enable_ttwebid=e.enable_ttwebid||!1,this.domain=e.channel_domain||decodeUrl(LOG_URL[e.channel]),this.tokenReady=!1,this.checkExp=e.checkExp||!1,this.enableCookie=e.cross_subdomain||!1,this.expiresTime=94608e6,this.fetchUrl=""+this.domain+WEBID_URL,this.hook=i,this.session=n,this.cookieDomain=e.cookie_domain||"";}return e.prototype._getToken=function(){this.tokensKey=CACHEKEY(this.appInfo,!0),this.cookieKey=COOKIEKEY(this.appInfo);var e=this.storage.getItem(this.tokensKey),t=this.storage.getCookie(this.cookieKey,this.cookieDomain);if(this.enable_ttwebid)if(e){var i={user_unique_id:e.user_unique_id||"",timestamp:Date.now()};this.storage.setItem(this.tokensKey,i),this._setTtWid(e,!1);}else this._setTtWid(e,!0);else if(this.enableCookie)if(t){var n=(t=JSON.parse(decodeURIComponent(t))).user_unique_id,o=t.web_id,r=t.timestamp;this._setToken(o,n,r);}else {if(!e)return void this._requestWebId();this.storage.setCookie(this.cookieKey,encodeURIComponent(JSON.stringify(e)),this.expiresTime,this.cookieDomain),this._checkLocal(e);}else {if(!e)return void this._requestWebId();this._checkLocal(e);}},e.prototype._checkLocal=function(e){var t=e.user_unique_id,i=e.web_id,n=e.timestamp;i&&t?this._setToken(i,t,n):this._requestWebId();},e.prototype._setToken=function(e,t,i){if(this.checkExp){var n=Date.now()-parseFloat(i);if(n>7344e6)return void this._requestWebId();if(n>432e7)return void this._updateWebId(e)}this.cfg.envInfo.user.user_unique_id=t,this.cfg.envInfo.user.web_id=e,this.storage.setItem(this.tokensKey,{user_unique_id:t,web_id:e,timestamp:Date.now()}),this.tokenReady=!0;},e.prototype._requestWebId=function(){this.isNoWebid?this._setTokenId(webid()):this._fetchWebId(this.fetchUrl,!1);},e.prototype._updateWebId=function(e){var t=""+this.domain+WEBID_URL+"/"+e+"/update";this._fetchWebId(t,!0);},e.prototype._fetchWebId=function(e,t){var i=this;request$1(e,3e3,{app_key:this.config.app_key,app_id:this.config.app_id,url:location.href,user_agent:window.navigator.userAgent,referer:document.referrer,user_unique_id:""},this.config.app_key,function(e){e&&0===e.e?i._setTokenId(e.web_id):(i.hook.emit("token-error"),console.warn("[]appid: "+i.config.app_id+", "+(t?" update":"get")+" webid error, init error~"));},function(){i.hook.emit("token-error"),console.warn("[]appid: "+i.config.app_id+", get webid error, init error~");},!0,!1,this.enable_ttwebid);},e.prototype._setTtWid=function(e,t){if(!t){var i={web_id:e.web_id||"",timestamp:Date.now()},n=e.user_unique_id||"";this.cfg.envInfo.user.user_unique_id=this.cfg.envInfo.user.user_unique_id||n,this.storage.setCookie(this.cookieKey,encodeURIComponent(JSON.stringify(i)),108e5,this.cookieDomain);}this.tokenReady=!0,this.hook.emit("token-ready");},e.prototype._setTokenId=function(e){var t=this.cfg.envInfo.user.web_id||e,i={web_id:t,user_unique_id:this.cfg.envInfo.user.user_unique_id||t,timestamp:Date.now()};this.enableCookie&&this.storage.setCookie(this.cookieKey,encodeURIComponent(JSON.stringify(i)),this.expiresTime,this.cookieDomain),this.storage.setItem(this.tokensKey,i),this.cfg.envInfo.user.web_id=this.cfg.envInfo.user.web_id||t,this.cfg.envInfo.user.user_unique_id=this.cfg.envInfo.user.user_unique_id||t,this.tokenReady=!0,this.hook.emit("token-ready");},e.prototype._setUuid=function(e){try{var t=this.storage.getItem(this.tokensKey);if(e){"string"!=typeof e&&console.warn("user_unique_id must be string!!! please check");var i=String(e);this.cfg.envInfo.user.user_unique_id=i,t&&t.user_unique_id?t.user_unique_id!==i&&(t.user_unique_id=i,this.hook.emit("uuid-change")):((t={}).user_unique_id=i,this.hook.emit("uuid-change")),t.timestamp=Date.now(),this.storage.setItem(this.tokensKey,t),this.session._resetSessionId();}else this._clearUuid(t);}catch(e){}},e.prototype._clearUuid=function(e){this.enable_ttwebid||e&&e.web_id&&(this.cfg.envInfo.user.user_unique_id=e.web_id,e.user_unique_id=e.web_id,e.timestamp=Date.now(),this.storage.setItem(this.tokensKey,e));},e.prototype._setWebid=function(e){if(!this.enable_ttwebid){var t=this.storage.getItem(this.tokensKey),i=!1;t&&t.web_id?t.web_id!==e&&(t.user_unique_id=t.web_id===t.user_unique_id?e:t.user_unique_id,t.web_id=e,this.cfg.envInfo.user.user_unique_id&&this.cfg.envInfo.user.user_unique_id!==this.cfg.envInfo.user.web_id||(this.cfg.envInfo.user.user_unique_id=e,i=!0)):(t={}).web_id=e,t.timestamp=Date.now(),this.cfg.envInfo.user.web_id=e,this.storage.setItem(this.tokensKey,t),i&&this.hook.emit("uuid-change");}},e.prototype.isTokenReady=function(){return this.tokenReady},e.prototype._getTobId=function(e){var t=""+this.domain+TOB_URL;request$1(t,3e4,{app_id:this.config.app_id,user_unique_id:this.cfg.envInfo.user.user_unique_id,web_id:this.cfg.envInfo.user.web_id},this.config.app_key,function(t){t&&0===t.e?e(t.tobid):e(null);},function(){e(null);},!0,!1,this.enable_ttwebid);},e}(),beforePageUnload=function(e){!!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)?window.addEventListener("pagehide",e,!1):window.addEventListener("beforeunload",e,!1);},EventManager=function(){function e(e,t,i,n,o,r){this.collect=e,this.cfg=i,this.config=t,this._token=n,this.appInfo=t.app_key||t.app_id,this.debugMode=!!t.log,this.evtDataKey=CACHEKEY(this.appInfo,!1);var s=t.channel_domain||decodeUrl(LOG_URL[t.channel]);this.reportUrl=t.report_url?t.report_url:""+s+REPORT_URL,this.storage=new Storage(!0),this.EventStorage=new Storage(!1),this.maxStorage=t.max_storage_num||-1,this.maxReport=t.max_report||20,this.reportTime=t.reportTime||30,this.timeout=t.timeout||0,this.closeStorage=!0,this.session=r,this.plugin=o,this.withCredentials=t.enable_ttwebid,this.addListener();}return e.prototype.addListener=function(){var e=this;window.addEventListener("unload",function(){e.report(!0);},!1),beforePageUnload(function(){e.report(!0);}),document.addEventListener("visibilitychange",function(){"hidden"===document.visibilityState&&e.report(!0);},!1);},e.prototype.setReady=function(){this.isReady=!0,this.report();},e.prototype.event=function(e){var t=this;void 0===e&&(e=[]);var i=__spread(e,this.storage.getItem(this.evtDataKey)||[]);this.storage.setItem(this.evtDataKey,i),this.reportTimer&&clearTimeout(this.reportTimer),i.length>=this.maxReport?this.report(!1):this.reportTimer=setTimeout(function(){t.report(!1),t.reportTimer=null;},this.reportTime);},e.prototype.beconEvent=function(e){void 0===e&&(e=[]);var t=this._mergeEvents(e);this._dealData(t,!0);},e.prototype.report=function(e){if(void 0===e&&(e=!1),!this.collect.destroyInstance&&this._token.isTokenReady()&&this.isReady){var t=this.storage.getItem(this.evtDataKey)||[],i=this._mergeEvents(t);this.storage.removeItem(this.evtDataKey),this._dealData(i,e);}},e.prototype._mergeEvents=function(e){var t=this;if(!e.length)return e;var i=this.cfg.get();i.header.custom=JSON.stringify(i.header.custom);var n=[];return n.push(e),n.map(function(e){return {events:e.map(function(e){var i=__assign({},t.cfg.get("evtParams"),e.params);return delete i.__disable_storage__,__assign({},e,{params:JSON.stringify(i),session_id:t.session._getSessionId()})}),user:i.user,header:i.header,verbose:t.debugMode?1:void 0}})},e.prototype._dealData=function(e,t){var i=this;if(!e.length)return e;e.map(function(e){var t=[];return t.push(e),t}).forEach(function(e){var n=webid();i._send(n,e,t);});},e.prototype._send=function(e,t,i){var n=this;this.isSending=!0;var o=function(){n.isSending=!1;};request$1(this.reportUrl,this.timeout,t,this.config.app_key,function(){o();},function(e,t){o(),n.cfg.get("reportErrorCallback")(e,t);},!1,i,this.withCredentials,o);},e.prototype.checkStorageEvent=function(){},e}(),UTM=function(e,t,i){var n=new Storage(!1),o=new Storage(!1,"session"),r=e?"_tea_utm_cache_"+e:"_tea_utm_cache",s=e?"_$utm_from_url_"+e:"_$utm_from_url",a={},c=["tr_shareuser","tr_admaster","tr_param1","tr_param2","tr_param3","tr_param4","$utm_from_url"],u={utm_source:t.utm_source,utm_medium:t.utm_medium,utm_campaign:t.utm_campaign,utm_term:t.utm_term,utm_content:t.utm_content,tr_shareuser:t.tr_shareuser,tr_admaster:t.tr_admaster,tr_param1:t.tr_param1,tr_param2:t.tr_param2,tr_param3:t.tr_param3,tr_param4:t.tr_param4};try{var h=!1;for(var d in u)u[d]&&(-1!==c.indexOf(d)?(a.hasOwnProperty("tracer_data")||(a.tracer_data={}),a.tracer_data[d]=u[d]):a[d]=u[d],h=!0);if(h)o.setItem(s,"1"),n.setCookie(r,JSON.stringify(a),7776e6,i);else {var f=n.getCookie(r,i);f&&(a=JSON.parse(f));}o.getItem(s)&&(a.tracer_data.$utm_from_url=1);}catch(e){return u}return a},client=function(e,t){var i,n,o=function(e){var t=document.createElement("a");return t.href=e,t},r=window.screen.width,s=window.screen.height,a=window.navigator.appVersion,c=window.navigator.userAgent,u=window.navigator.language,h=document.referrer,d=h?o(h).hostname:"",f=function(e){var t=o(e).search;t=t.slice(1);var i={};return t.split("&").forEach(function(e){var t,n,o=e.split("=");o.length&&(t=o[0],n=o[1]);try{i[t]=decodeURIComponent(void 0===n?"":n);}catch(e){i[t]=n;}}),i}(window.location.href),_="",p="",g="",m=""+parseFloat(a);-1!==(i=c.indexOf("Opera"))&&(g="Opera",m=c.substring(i+6),-1!==(i=c.indexOf("Version"))&&(m=c.substring(i+8))),-1!==(i=c.indexOf("Edge"))?(g="Microsoft Edge",m=c.substring(i+5)):-1!==(i=c.indexOf("MSIE"))?(g="Microsoft Internet Explorer",m=c.substring(i+5)):-1!==c.indexOf("Chrome")?-1!==(i=c.indexOf("Chrome"))&&(g="Chrome",m=c.substring(i+7)):-1!==c.indexOf("Safari")?-1!==(i=c.indexOf("Safari"))&&(g="Safari",m=c.substring(i+7),-1!==(i=c.indexOf("Version"))&&(m=c.substring(i+8))):-1!==(i=c.indexOf("Firefox"))&&(g="Firefox",m=c.substring(i+8)),-1!==(n=m.indexOf(";"))&&(m=m.substring(0,n)),-1!==(n=m.indexOf(" "))&&(m=m.substring(0,n)),-1!==(n=m.indexOf(")"))&&(m=m.substring(0,n));for(var l,v,y=/Mobile|htc|mini|Android|iP(ad|od|hone)/.test(a)?"wap":"web",w=[{s:"Windows 10",r:/(Windows 10.0|Windows NT 10.0)/},{s:"Windows 8.1",r:/(Windows 8.1|Windows NT 6.3)/},{s:"Windows 8",r:/(Windows 8|Windows NT 6.2)/},{s:"Windows 7",r:/(Windows 7|Windows NT 6.1)/},{s:"Android",r:/Android/},{s:"Sun OS",r:/SunOS/},{s:"Linux",r:/(Linux|X11)/},{s:"iOS",r:/(iPhone|iPad|iPod)/},{s:"Mac OS X",r:/Mac OS X/},{s:"Mac OS",r:/(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/}],I=0;I<w.length;I++){var k=w[I];if(k.r.test(c)){_=k.s;break}}function b(e,t){var i=e.exec(t);return i&&i[1]?i[1]:""}switch(/Windows/.test(_)&&(p=b(/Windows (.*)/,_),_="windows"),_){case"Mac OS X":l=c,p=(v=RegExp("(?:^|[^A-Z0-9-_]|[^A-Z0-9-]_|sprd-)(?:"+"Mac[ +]OS[ +]X(?:[ /](?:Version )?(\\d+(?:[_\\.]\\d+)+))?"+")","i").exec(l))?v.slice(1)[0]:"",_="mac";break;case"Android":p=function(e){var t=b(/Android ([\.\_\d]+)/,e);return t||(t=b(/Android\/([\.\_\d]+)/,e)),t}(c),_="android";break;case"iOS":p=(p=/OS (\d+)_(\d+)_?(\d+)?/.exec(a))?p[1]+"."+p[2]+"."+(0|p[3]):"",_="ios";}var S=UTM(e,f,t);return {browser:g,browser_version:m,platform:y,os_name:_,os_version:p,userAgent:c,screen_width:r,screen_height:s,device_model:function(e){var t="";try{if("android"===e)navigator.userAgent.split(";").forEach(function(e){e.indexOf("Build/")>-1&&(t=e.slice(0,e.indexOf("Build/")));});else if("ios"===e||"mac"===e){var i=navigator.userAgent.replace("Mozilla/5.0 (",""),n=i.indexOf(";");t=i.slice(0,n);}}catch(e){}return t.trim()}(_),language:u,referrer:h,referrer_host:d,utm_source:S.utm_source,utm_medium:S.utm_medium,utm_campaign:S.utm_campaign,utm_term:S.utm_term,utm_content:S.utm_content}},undef=void 0,date=new Date,timeZoneMin=date.getTimezoneOffset(),timezone=parseInt(""+-timeZoneMin/60,10),tz_offset=60*timeZoneMin,ConfigManager=function(){function e(e,t,i){this.cookieDomain=t.cookie_domain||"",this.initConfig=t;var n=client(e,this.cookieDomain);this.configKey=CONFIGKEY(""+e),this.sessionStorage=new Storage(!1,"session"),this.localStorage=new Storage(!1,"local"),i&&(this.storage=1===i?this.sessionStorage:this.localStorage),this.envInfo={user:{user_unique_id:undef,user_type:undef,user_id:undef,user_is_auth:undef,user_is_login:undef,device_id:undef,web_id:undef,ip_addr_id:undef},header:{app_id:undef,app_name:undef,app_install_id:undef,install_id:undef,app_package:undef,app_channel:undef,app_version:undef,os_name:n.os_name,os_version:n.os_version,device_model:n.device_model,ab_client:undef,ab_version:undef,ab_sdk_version:undef,traffic_type:undef,client_ip:undef,device_brand:undef,os_api:undef,access:undef,language:n.language,region:undef,app_language:undef,app_region:undef,creative_id:undef,ad_id:undef,campaign_id:undef,log_type:undef,rnd:undef,platform:n.platform,sdk_version:SDK_VERSION,sdk_lib:"js",province:undef,city:undef,timezone:timezone,tz_offset:tz_offset,tz_name:undef,sim_region:undef,carrier:undef,resolution:n.screen_width+"x"+n.screen_height,browser:n.browser,browser_version:n.browser_version,referrer:n.referrer,referrer_host:n.referrer_host,width:n.screen_width,height:n.screen_height,screen_width:n.screen_width,screen_height:n.screen_height,utm_term:n.utm_term,utm_content:n.utm_content,utm_source:n.utm_source,utm_medium:n.utm_medium,utm_campaign:n.utm_campaign,tracer_data:JSON.stringify(n.tracer_data),custom:{}}},this.evtParams={},this.reportErrorCallback=function(){};}return e.prototype.set=function(e,t){var i=this;if(t||(this.delete(e),t=void 0),"evtParams"===e||"_staging_flag"===e){var n;n="evtParams"===e?t:{_staging_flag:Number(t)};var o=__assign({},n);Object.keys(o).forEach(function(e){i.evtParams[e]=o[e];});}else if("reportErrorCallback"===e&&"function"==typeof t)this.reportErrorCallback=t;else {var r="";if(e.indexOf(".")>-1){var s=e.split(".");r=s[0],e=s[1];}"os_version"===e&&(e=""+t),r?"user"===r||"header"===r?this.envInfo[r][e]=t:this.envInfo.header.custom[e]=t:this.envInfo.user.hasOwnProperty(e)?["user_type","ip_addr_id"].indexOf(e)>-1?this.envInfo.user[e]=t?Number(t):t:["user_id"].indexOf(e)>-1?this.envInfo.user[e]=t?String(t):t:["user_is_auth","user_is_login"].indexOf(e)>-1?this.envInfo.user[e]=Boolean(t):"device_id"===e&&(this.envInfo.user[e]=t):this.envInfo.header.hasOwnProperty(e)?this.envInfo.header[e]=t:this.envInfo.header.custom[e]=t;}},e.prototype.get=function(e){try{return e?"evtParams"===e?this.evtParams:"reportErrorCallback"===e?this[e]:JSON.parse(JSON.stringify(this.envInfo[e])):JSON.parse(JSON.stringify(this.envInfo))}catch(e){console.log("get config stringify error ");}},e.prototype.setStore=function(e){try{var t=this.storage.getItem(this.configKey);if(Object.keys(e).length){var i=Object.assign(e,t);this.storage.setItem(this.configKey,i);}}catch(e){}},e.prototype.getStore=function(){try{var e=this.storage.getItem(this.configKey);return Object.keys(e).length?e:null}catch(e){return null}},e.prototype.delete=function(e){try{var t=this.storage.getItem(this.configKey);t&&t.hasOwnProperty(e)&&(delete t[e],this.storage.setItem(this.configKey,t));}catch(e){}},e}(),Logger=function(){function e(e,t){this.isLog=t,this.name=e||"";}var t=e.prototype;return t.info=function(e){this.isLog&&console.log("["+this.name+"] "+e);},t.warn=function(e){this.isLog&&console.warn("["+this.name+"] "+e);},t.error=function(e){this.isLog&&console.error("["+this.name+"] "+e);},t.throw=function(e){throw this.error(this.name),new Error(e)},e}(),sessionId=function(){return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,function(e){var t=16*Math.random()|0;return ("x"===e?t:3&t|8).toString(16)})},Session=function(){function e(e,t){this.storage=new Storage(!1,"session"),this.sessionKey=SESSIONKEY(e),this.disableSession=t.disable_session,this.expireTime=t.expireTime||18e5,this.disableSession||this._setSessionId();}return e.prototype._updateSessionId=function(){var e=this.storage.getItem(this.sessionKey);if(e&&e.sessionId){var t=e.timestamp;Date.now()-t>this.expireTime?e={sessionId:sessionId(),timestamp:Date.now()}:e.timestamp=Date.now(),this.storage.setItem(this.sessionKey,e),this._resetExpTime();}},e.prototype._setSessionId=function(){var e=this,t=this.storage.getItem(this.sessionKey);t&&t.sessionId?t.timestamp=Date.now():t={sessionId:sessionId(),timestamp:Date.now()},this.storage.setItem(this.sessionKey,t),this.sessionExp=setInterval(function(){e._checkEXp();},this.expireTime);},e.prototype._getSessionId=function(){if(this.disableSession)return "";var e=this.storage.getItem(this.sessionKey);return e&&e.sessionId?e.sessionId:null},e.prototype._resetExpTime=function(){var e=this;this.sessionExp&&(clearInterval(this.sessionExp),this.sessionExp=setInterval(function(){e._checkEXp();},this.expireTime));},e.prototype._resetSessionId=function(){var e={sessionId:sessionId(),timestamp:Date.now()};this.storage.setItem(this.sessionKey,e);},e.prototype._checkEXp=function(){var e=this.storage.getItem(this.sessionKey);if(e&&e.sessionId){var t=Date.now()-e.timestamp;t+30>=this.expireTime&&(console.log(t),e={sessionId:sessionId(),timestamp:Date.now()},this.storage.setItem(this.sessionKey,e));}},e}(),Hook=function(){function e(){this._hooks={};}return e.prototype.on=function(e,t){e&&t&&"function"==typeof t&&(this._hooks[e]||(this._hooks[e]=[]),this._hooks[e].push(t));},e.prototype.once=function(e,t){var i=this;if(e&&t&&"function"==typeof t){this.on(e,function n(o){t(o),i.off(e,n);});}},e.prototype.off=function(e,t){if(e&&this._hooks[e]&&this._hooks[e].length)if(t){var i=this._hooks[e].indexOf(t);-1!==i&&this._hooks[e].splice(i,1);}else this._hooks[e]=[];},e.prototype.emit=function(e,t){e&&this._hooks[e]&&this._hooks[e].length&&__spread(this._hooks[e]).forEach(function(e){try{e(t);}catch(e){}});},e}(),exportMethods=["profileSet","profileSetOnce","profileIncrement","profileUnset","profileAppend","getVar","getAbSdkVersion","onAbSdkVersionChange","offAbSdkVersionChange","getABconfig","openOverlayer","closeOverlayer","getAllVars","setExternalAbVersion","getToken","destroy"],Methods=__spread(["init","config","send","start","predefinePageView","beconEvent","resetStayDuration"],exportMethods),getIndex=function(){var e=+Date.now()+Number((""+Math.random()).slice(2,8));return function(){return e+=1}}(),Collector=function(){function e(e){var t=this;this.staging=!1,this._getToken=!1,this.sdkload=!1,this.initPv=!0,this.predefinePageView=function(e){void 0===e&&(e={});var i=__assign({title:document.title||location.pathname,url:location.href,url_path:location.pathname,time:Date.now(),referrer:window.document.referrer},t._event.closeStorage?{}:{__disable_storage__:1},{$is_first_time:""+t.is_first_time}),n=__assign({},i,e);t.event("predefine_pageview",n,!0);},this.getToken=function(e,t){},this.name=e,this._isSend=!1,this.autoPV=!0,this.hook=new Hook,this.storage=new Storage(!1);}return e.prototype.init=function(e){var t=this;if(!this._inited){if(this._inited=!0,!e||"object"!=typeof e)throw new Error("init params is error,please check");var i=e.app_id,n=e.app_key,o=e.log;this._config=new ConfigManager(i,e,e.configPersist||0),this.logger=new Logger(this.name,o),n||i||this.logger.throw("no app_key or app_id please check"),i&&"number"!=typeof i&&this.logger.throw("app_id param is error,must be number,please check "),n&&"string"!=typeof n&&this.logger.warn("app_key is empty"),e.channel_domain||-1!==["sg","va","in"].indexOf(e.channel)||this.logger.throw("channel must be `sg`,`va`,`in`"),this._config.set("app_id",i),e.channel=e.channel?e.channel:"sg",this._initConfig=e,this.storage.getItem("__tea_cache_first_"+i)?this.is_first_time=!1:(this.is_first_time=!0,this.storage.setItem("__tea_cache_first_"+i,"1")),this.sdkload=!0,this.hook.on("token-ready",function(){t.callbackSend?t._isSend?t._event&&t._event.report():t.start():t._event&&t._event.report();}),this._session=new Session(n||i,e),this._token=new Token(e,this._config,this.hook,this._session),this._event=new EventManager(this,e,this._config,this._token,this.plugin,this._session),this._token._getToken();}},e.prototype.config=function(e){if(this._inited)if(e&&"object"==typeof e){e.disable_auto_pv&&(this.autoPV=!1,delete e.disable_auto_pv),e._staging_flag&&1===e._staging_flag&&(this.staging=!0);var t=__assign({},e);if(this.configPersist){var i=this._config.getStore();i&&(t=Object.assign(i,e)),this._config.setStore(e);}for(var n in t)"user_unique_id"!==n?"web_id"!==n?this._config.set(n,t[n]):this._token._setWebid(t[n]):this._token._setUuid(t[n]);}else this.logger.warn("config params is error, please check");else this.logger.warn("config must be use after function init");},e.prototype.send=function(){this.start();},e.prototype.start=function(){var e=this;if(this._token.isTokenReady()){if(this._isSend)return;this._isSend=!0,this.logger.info("appid:"+this._initConfig.app_id+", userInfo:"+JSON.stringify(this._config.get("user"))),this.logger.info("sdk is ready,version is "+SDK_VERSION+". you can report now !!!"),this._event.setReady(),this.autoPV&&(this.predefinePageView(),this.initPv=!1),this.hook.on("uuid-change",function(){if(!e.initPv){var t={title:document.title||location.pathname,url:location.href,url_path:location.pathname,time:Date.now(),referrer:window.document.referrer,$is_first_time:""+e.is_first_time};e.beconEvent("predefine_pageview",t);}}),this._getToken&&this.hook.emit("get-token");}else this.callbackSend=!0;},e.prototype.beconEvent=function(e,t){var i=[];i.push([e,t]),this._dealEvent(!0,i);},e.prototype.event=function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];var i=__read(e,1)[0],n=[];"Array"!==Object.prototype.toString.call(i).slice(8,-1)?n[0]=e:n=e,this._dealEvent(!1,n);},e.prototype._dealEvent=function(e,t){var i=this;try{t=t.map(function(e){var t=e[0];/^event\./.test(e[0])&&(t=e[0].slice(6));var n,o=e[1];return "object"!=typeof o&&(o={}),o.profile?delete o.profile:o.event_index=getIndex(),o.local_ms?(n=o.local_ms,delete o.local_ms):n=+new Date,{event:t,params:o,local_time_ms:n,is_bav:i._initConfig.autotrack?1:0}}),e?this._event.beconEvent(t):this._event.event(t),this._session._updateSessionId();}catch(e){}},e.prototype.resetStayDuration=function(e,t,i){},e.prototype.setExternalAbVersion=function(e){},e.prototype.getABconfig=function(e,t){},e.prototype.getVar=function(e,t,i){},e.prototype.getAbSdkVersion=function(e){},e.prototype.onAbSdkVersionChange=function(e){},e.prototype.offAbSdkVersionChange=function(e){},e.prototype.openOverlayer=function(){},e.prototype.closeOverlayer=function(){},e.prototype.getAllVars=function(e){},e.prototype.profileSet=function(e){},e.prototype.profileSetOnce=function(e){},e.prototype.profileIncrement=function(e){},e.prototype.profileUnset=function(e){},e.prototype.profileAppend=function(e){},e.prototype.destroy=function(){this.destroyInstance||(this.destroyInstance=!0);},e}(),CollectAsync=function(e){var t=this;return _defineProperty(this,"_exportCollect",function(){for(var e=arguments.length,i=new Array(e),n=0;n<e;n++)i[n]=arguments[n];t._isProcess?t._executeCmd.apply(t,i):(t.cmdQueue.push(i),t._processCmd());}),_defineProperty(this,"_processCmd",function(){if(0!==t.cmdQueue.length){var e,i,n,o,r=(e=t.cmdQueue,i="init",n="0",o=-1,e.forEach(function(e,t){(void 0!==n?e[n]:e)===i&&(o=t);}),o);-1!==r&&(t._isProcess=!0,t._executeCmd.apply(t,t.cmdQueue[r]),t.cmdQueue.forEach(function(e,i){i!==r&&t._executeCmd.apply(t,e);}),t.cmdQueue=[]);}}),_defineProperty(this,"_executeCmd",function(){for(var e=arguments.length,i=new Array(e),n=0;n<e;n++)i[n]=arguments[n];var o,r,s=i[0];Methods.indexOf(s)>-1?(o=t.colloctor)[s].apply(o,i.slice(1)):(r=t.colloctor).event.apply(r,i);}),this.cmdQueue=[],this.name=e,this.colloctor=new Collector(e),this._isProcess=!1,this._alias={},this._processCmd(),Methods.forEach(function(e){t._exportCollect[e]=t._exportCollect.bind(t,e);}),this._exportCollect};var CollectorBaseClient_min=CollectAsync;

var MAP_APPID = {
    CN: 3053,
    OVERSEA: 3297,
};
function createTracker(options) {
    var isTest = options.isTest, channel_domain = options.channel_domain;
    var isOversea = channel_domain.includes('oversea') || channel_domain.includes('useast');
    var appId = isOversea ? MAP_APPID.OVERSEA : MAP_APPID.CN;
    var tracker = new CollectorBaseClient_min('tracker');
    tracker.init({
        app_id: appId,
        channel_domain: channel_domain,
    });
    tracker.config({
        _staging_flag: isTest,
        enable_et_test: isTest,
    });
    tracker.start();
    return tracker;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function serialize(val) {
    return JSON.stringify(val);
}
function deserialize(val) {
    if (typeof val !== 'string') {
        return undefined;
    }
    try {
        return JSON.parse(val);
    }
    catch (e) {
        return val || undefined;
    }
}
var Store = /** @class */ (function () {
    function Store() {
    }
    Store.prototype.get = function (key) {
        if (!localStorage || !localStorage.getItem)
            return;
        return deserialize(localStorage.getItem(key));
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Store.prototype.set = function (key, val) {
        if (!localStorage || !localStorage.setItem)
            return;
        localStorage.setItem(key, serialize(val));
    };
    return Store;
}());
var store = new Store();

var StarlingWebError = /** @class */ (function (_super) {
    __extends$1(StarlingWebError, _super);
    function StarlingWebError(message, url, code, request, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    response, useWebCache) {
        var _this = _super.call(this, message) || this;
        _this.url = url;
        _this.code = code;
        _this.request = request;
        _this.response = response;
        _this.useWebCache = useWebCache;
        _this.url = url;
        _this.code = code;
        _this.request = request;
        _this.response = response;
        _this.useWebCache = !!useWebCache;
        return _this;
    }
    return StarlingWebError;
}(Error));

/**
 * @author: fengweiyao@bytedance.com
 * almost copy from axios
 */
/**
 * 安全的 JSON.parse，如果 parse 失败，则会返回空 Object
 * @param data 将要被 parse 的 string 数据
 */
function _safeParse(data) {
    try {
        return JSON.parse(data);
    }
    catch (error) {
        return {};
    }
}
/**
 * 检验拉取文案数据，应当为 "{"data": {"message": {"keyText": "TargetText"}}}" 格式
 * 即 typeof _.data.message === 'object' 且不为 undefined
 */
function _checkTextData(_) {
    if (!_.message || typeof _.message !== 'object') {
        return null;
    }
    return _;
}
/**
 * 响应错误处理
 */
function _responseErrHandler(request, reject, url, uncheckedResponseData) {
    // 如果 uncheckedResponseData 里面存在失败原因（message），则也需要吐回去
    var errorMessage = (uncheckedResponseData || {}).message || '';
    errorMessage = errorMessage ? ', reason is: '.concat(errorMessage) : '';
    reject(new StarlingWebError('Request failed with status code ' + request.status + errorMessage, url, null, request, { data: {} }, // todo:: 失败了需要返回 localStorage 缓存？
    true));
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function request(url, options) {
    var timeout = options.timeout;
    return new Promise(function (resolve, reject) {
        var request = new XMLHttpRequest();
        request.open('GET', url);
        request.withCredentials = false;
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) {
                return;
            }
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 &&
                !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
                return;
            }
            // 没经过规范校验的 response，可能是 {"message":"none project match this app_key", "status":1000} 格式
            var uncheckedResponseData = _safeParse(request.responseText);
            // 经过规范校验的 response，可能是 null 或者 message 为文案 Object
            var checkedResponseData = _checkTextData(uncheckedResponseData);
            if (request.status < 200 || request.status >= 300 || !checkedResponseData) {
                _responseErrHandler(request, reject, url, uncheckedResponseData);
                request = null;
                return;
            }
            var response = {
                data: checkedResponseData,
                status: request.status,
                statusText: request.statusText,
                request: request,
            };
            resolve(response);
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            // 就算是断网了，也得去看看 cache 里面有没有
            reject(new StarlingWebError('Network Error', url, null, request, { data: {} }, true));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.timeout = timeout;
        request.ontimeout = function handleTimeout() {
            reject(new StarlingWebError('timeout of ' + timeout + 'ms exceeded', url, 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        request.send();
    });
}

var StarlingWeb = /** @class */ (function (_super) {
    __extends$1(StarlingWeb, _super);
    function StarlingWeb(options) {
        var _this = this;
        var test = options.test, TEAChannelDomain = options.TEAChannelDomain, mode = options.mode;
        options.tracker = TEAChannelDomain
            ? createTracker({
                isTest: test || mode === 'test',
                channel_domain: TEAChannelDomain,
            })
            : function () { };
        if (!options.store)
            options.store = store;
        if (!options.request)
            options.request = request;
        _this = _super.call(this, options) || this;
        return _this;
    }
    return StarlingWeb;
}(Starling));

export { StarlingWeb as default };
